import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

import { colorsPalette, LARGE_MARGIN, MIDDLE_MARGIN, SMALL_MARGIN } from '../../../../theme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    wrapper: {
      '& .ais-InfiniteHits-list': {
        listStyleType: 'none',
        paddingLeft: 0,
        [theme.breakpoints.up('md')]: {
          '& > li': {
            marginBottom: 32,
            paddingBottom: 32,
            borderBottom: `1px solid ${colorsPalette.violetAnalyticsCard}`,
            '&:last-child': {
              borderBottom: 'none',
              marginBottom: 0,
            },
          },
        },
      },
      '& .ais-InfiniteHits-list.ais-GlossaryInfiniteHits-list': {
        '& > li': {
          marginBottom: MIDDLE_MARGIN,
          paddingBottom: 0,
          borderBottom: 'none',
          [theme.breakpoints.up('md')]: {
            marginBottom: LARGE_MARGIN,
          },
          '&:last-child': {
            marginBottom: MIDDLE_MARGIN,
            [theme.breakpoints.up('md')]: {
              marginBottom: LARGE_MARGIN,
            },
          },
          '&.hit-letter': {
            paddingBottom: SMALL_MARGIN / 2,
            borderBottom: `3px solid ${colorsPalette.violetAnalyticsCard}`,
          },
        },
      },
      '& .ais-InfiniteHits-grid': {
        listStyleType: 'none',
        paddingLeft: 0,
        display: 'flex',
        justifyContent: 'flex-start',
        flexWrap: 'wrap',
        margin: 0,
        marginRight: `-${SMALL_MARGIN}px`,
        '& > li': {
          marginRight: SMALL_MARGIN,
          width: `calc((100% - ${3 * SMALL_MARGIN}px) / 3)`,
        },
      },
    },
    viewBtn: {
      width: '100%',
      textTransform: 'none',
      textAlign: 'center',
      fontSize: 18,
      lineHeight: 1,
      padding: SMALL_MARGIN,
      color: '#B5B1C1',
      background: '#3A354D',
      borderRadius: 5,
      fontWeight: 'bold',
      '@media (hover: none)': {
        '&:hover': {
          backgroundColor: '#3A354D',
        },
      },
    },
    modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    dialog: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      '&:focus': {
        outline: 'none',
      },
    },
  }),
);

export default useStyles;
